/**
 * KpiStrip — live KPI cards rendered above Today inbox.
 */
import { useEffect, useState } from "react";
import { Users, DollarSign, Calendar, Flame, AlertCircle, TrendingUp } from "lucide-react";
import { api } from "../lib/api";

export default function KpiStrip() {
  const [k, setK] = useState(null);
  useEffect(() => {
    let timer;
    const load = async () => {
      try {
        const { data } = await api.get("/dealer/kpis/today");
        setK(data);
      } catch { /* noop */ }
    };
    load();
    timer = setInterval(load, 60000); // refresh every minute
    return () => clearInterval(timer);
  }, []);
  if (!k) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2.5" data-testid="kpi-strip">
      <Card label="New today" value={k.new_leads_today} delta={k.new_leads_delta} icon={Users} testid="kpi-newleads" />
      <Card label="Hot leads" value={k.hot_leads} icon={Flame} highlight={k.hot_leads > 0} testid="kpi-hot" />
      <Card label="Appts today" value={k.appts_today} icon={Calendar} testid="kpi-appts" />
      <Card label="Sold today" value={k.sold_today} icon={TrendingUp} testid="kpi-sold" />
      <Card label="Gross today" value={`$${Math.round(k.gross_today).toLocaleString()}`} icon={DollarSign} testid="kpi-gross" />
      <Card label="Overdue tasks" value={k.overdue_tasks} icon={AlertCircle} alert={k.overdue_tasks > 0} testid="kpi-overdue" />
    </div>
  );
}

function Card({ label, value, delta, icon: Icon, alert, highlight, testid }) {
  const tone = alert ? "border-red-500/40 bg-red-500/5"
    : highlight ? "border-orange-500/40 bg-orange-500/5"
    : "border-white/15 bg-white/5";
  return (
    <div className={`rounded-xl border ${tone} p-3`} data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="text-[9px] font-extrabold uppercase tracking-widest text-white/70">{label}</div>
        <Icon size={13} className="text-white/60" />
      </div>
      <div className="flex items-baseline gap-1.5 mt-0.5">
        <div className="text-2xl font-black text-white">{value}</div>
        {typeof delta === "number" && delta !== 0 && (
          <div className={`text-[10px] font-extrabold ${delta > 0 ? "text-emerald-400" : "text-red-400"}`}>
            {delta > 0 ? "+" : ""}{delta}
          </div>
        )}
      </div>
    </div>
  );
}
